// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__3Yz7V","wrapper":"layout_wrapper__1K8E5","main":"layout_main__1wo4O"};